<template>
  <div class="w-full md:w-full h-full flex items-stretch relative">
    <input
      :value="answer"
      @blur="change(answer, Item)"
      @input="sendAnwswer($event.target.value)"
      v-validate="'email|required'"
      name="email"
      class="h-full py-2 border w-full px-2 bg-transparent font-family"
      :class="{
        'border-danger': errors.first('email'),
        'rounded-l-lg': errors.first('email'),
        'rounded-lg': !errors.first('email')
      }"
      type="text"
    />
    <div
      class="px-2 flex items-center cursor-pointer border-danger rounded-r-lg border-left-0"
      :class="{ _info: isToolTip }"
      v-if="errors.first('email')"
      @click="isToolTip = !isToolTip"
    >
      <feather-icon class="text-danger" icon="InfoIcon" svgClasses="w-5 h-5" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      isToolTip: false
    };
  },
  watch: {
    "errors.items": async function () {
      const vmId = this.errors.vmId;
      const items = this.errors.items;

      const element = items.find(item => item.vmId === vmId);
      if (!element) return (this.isToolTip = false);
    }
  },
  methods: {
    /**
     * Envia el valor y la validación (booleano) al componente padre vue.
     * @param {string} e - Valor ingresado en la caja de texto
     */
    async sendAnwswer(e) {
      const validate = await this.$validator.validateAll();
      this.$emit("input", e);
      this.$emit("validate", validate);
    }
  },
  computed: {
    answer: {
      get() {
        return this.value;
      },
    }
  }
};
</script>

<style lang="scss" scoped>
.border-danger {
  border: 1px solid rgba(234, 84, 85, 1) !important;
}

.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
}

.border-left-0 {
  border-left: none !important;
}

._info::before {
  content: "ejemplo@dominio.com";
  position: absolute;
  width: 97%;
  left: 0;
  top: 36px;
  background-color: black;
  color: white;
  padding: 5px;
  z-index: 1;
  border-radius: 0.5rem !important;
}
</style>
